import { CheckIcon } from '@phosphor-icons/react'

import { AccountBalanceWallet } from '@assets/svgs/AccountBalanceWallet'
import { CurrencyDollarSimple } from '@assets/svgs/CurrencyDollarSimple'
import { InfoIcon } from '@assets/svgs/InfoIcon'
import { TrendingDown } from '@assets/svgs/TrendingDown'
import { TrendingUp } from '@assets/svgs/TrendingUp'
import { currencyMask } from '@utils/masks/currencyMask'
import { TooltipExplanation } from '@components/shared/TooltipExplanation/inde'
import { PreviewCard } from '../PreviewCard'
import { getDeviationState } from './helpers'

import type { BudgetPreviewsProps } from './types'

const DEPRECIATION_WEEK_COLORS = ['#F5E2DA', '#E7D0BE', '#DABEA2', '#CCAD86', '#BF9C6A']
const BUDGET_BORDER = '#7B8794'

export const budgetPreviews = ({ data }: BudgetPreviewsProps) => {
  if (!data) return []

  const week = data.currentPreviewNumber ?? 3
  const previewBorderColor = DEPRECIATION_WEEK_COLORS[week - 1] ?? DEPRECIATION_WEEK_COLORS[2]

  const deviationState = getDeviationState(data.budgetAmount, data.previewCurrentAmount)

  return [
    <PreviewCard
      isBudget
      borderColor={BUDGET_BORDER}
      label="Budget"
      percentageValue={`${data.budgetPercentage.toFixed(2)}%`.replace('.', ',')}
      value={currencyMask(data.budgetAmount.toFixed(2))}
      icon={<AccountBalanceWallet />}
      bottomText="Orçamento aprovado"
      infoIcon={
        <TooltipExplanation
          data={[{ label: 'Budget (%) = ', text: '(Orçamento (R$) ÷ Budget de Faturamento (R$)) × 100' }]}
        >
          <InfoIcon />
        </TooltipExplanation>
      }
    />,
    <PreviewCard
      isBudget
      borderColor={previewBorderColor}
      label={!data.currentPreviewNumber ? 'Prévia' : `Prévia ${data.currentPreviewNumber}ª semana`}
      percentageValue={
        data.previewCurrentPercentage != null ? `${data.previewCurrentPercentage.toFixed(2)}%`.replace('.', ',') : undefined
      }
      value={currencyMask(data.previewCurrentAmount?.toFixed(2))}
      icon={<CurrencyDollarSimple />}
      bottomText="Previsão atual"
      infoIcon={
        <TooltipExplanation
          data={[
            { label: 'Prévia (%) = ', text: 'Total Depreciação / Total Faturamento x 100' },
            { label: 'Prévia (R$) = ', text: 'Total Depreciação (R$)' }
          ]}
        >
          <InfoIcon />
        </TooltipExplanation>
      }
    />,
    <PreviewCard
      label="Desvio (%)"
      borderColor={DEPRECIATION_WEEK_COLORS[DEPRECIATION_WEEK_COLORS.length - 1]}
      percentageValue={`${data.deviationPercentage?.toFixed(2)}%`}
      value={currencyMask(data.deviationValue?.toFixed(2))}
      deviationState={deviationState}
      icon={
        deviationState === 'none' ? <CheckIcon size={24} /> : deviationState === 'above' ? <TrendingUp /> : <TrendingDown />
      }
      bottomText={
        deviationState === 'none' ? 'Sem desvio' : deviationState === 'above' ? 'Acima do Budget' : 'Abaixo do Budget'
      }
      infoIcon={
        <TooltipExplanation
          data={[
            { label: 'Desvio (%) = ', text: 'Prévia (%) - Budget (%)' },
            { label: 'Desvio (R$) = ', text: 'Prévia (R$) - Budget (R$)' }
          ]}
        >
          <InfoIcon />
        </TooltipExplanation>
      }
    />
  ]
}
